"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _polished = require("polished");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _fearless = require("@zip/react-icons/fearless");

var _react = require("@emotion/react");

var _Button = require("../../../components/input/button/Button");

var _Icon = require("../../../components/icon/Icon");

var css = _interopRequireWildcard(require("./PaymentMethod.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = _styled["default"].button();

var CARD_TYPES = {
  BANKACCOUNT: 'bankaccount',
  MC: 'mc',
  VISA: 'visa'
};

var getIcon = function getIcon(cardType, isExpired, theme) {
  switch (cardType) {
    case CARD_TYPES.BANKACCOUNT:
      return (0, _jsxRuntime.jsx)("div", {
        css: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 18,
          height: 32,
          width: 32,
          backgroundColor: theme !== null && theme !== void 0 && theme.colors.accent ? (0, _polished.rgba)(theme === null || theme === void 0 ? void 0 : theme.colors.accent, 0.1) : undefined,
          borderRadius: '50%'
        },
        children: (0, _jsxRuntime.jsx)(_fearless.Bank, {
          css: {
            height: 18,
            width: 18,
            color: theme === null || theme === void 0 ? void 0 : theme.colors.secondary
          }
        })
      });

    case CARD_TYPES.MC:
      return (0, _jsxRuntime.jsx)(_Icon.Mastercard, {
        css: css.cardType(isExpired),
        size: 36
      });

    case CARD_TYPES.VISA:
      return (0, _jsxRuntime.jsx)(_Icon.Visa, {
        css: css.cardType(isExpired),
        size: 36
      });

    default:
      return null;
  }
};

var getCardType = function getCardType(cardType) {
  switch (cardType) {
    case CARD_TYPES.MC:
      return 'Mastercard';

    case CARD_TYPES.VISA:
      return 'Visa';

    default:
      return null;
  }
};

var displayCardNumber = function displayCardNumber(cardType, cardNumber, showCardType) {
  return "".concat(showCardType ? getCardType(cardType) : '', " ").concat(cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.slice(-8).replace(/.(?=.{4,}$)/g, "\u2022").replace(/\u2022([^\u2022]*)$/, "\u2022 $1"));
};

var PaymentMethod = function PaymentMethod(_ref) {
  var accountNumber = _ref.accountNumber,
      cardExpiry = _ref.cardExpiry,
      cardNumber = _ref.cardNumber,
      cardState = _ref.cardState,
      cardType = _ref.cardType,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      selected = _ref.selected,
      label = _ref.label,
      icon = _ref.icon,
      showCardType = _ref.showCardType,
      props = _objectWithoutProperties(_ref, ["accountNumber", "cardExpiry", "cardNumber", "cardState", "cardType", "onChange", "disabled", "selected", "label", "icon", "showCardType"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsxs)(Button // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - `as` is a valid prop
  , _objectSpread(_objectSpread({
    as: onChange ? 'div' : 'button',
    css: css.paymentMethod(selected, !onChange),
    disabled: disabled,
    role: onChange && 'button',
    type: "button"
  }, props), {}, {
    children: [getIcon(cardType, disabled, theme), (0, _jsxRuntime.jsxs)("div", {
      css: {
        flex: 2,
        textAlign: 'left'
      },
      children: [(0, _jsxRuntime.jsx)("span", {
        className: "body1",
        css: {
          display: 'block'
        },
        children: cardType.toLowerCase() === CARD_TYPES.BANKACCOUNT ? 'Bank account' : displayCardNumber(cardType, cardNumber, showCardType)
      }), (0, _jsxRuntime.jsxs)("span", {
        css: css.cardExpiry,
        children: [cardType.toLowerCase() === CARD_TYPES.BANKACCOUNT ? displayCardNumber('', accountNumber, false) : cardExpiry, cardState && (0, _jsxRuntime.jsx)("span", {
          css: css.cardStatus(disabled),
          children: cardState
        })]
      })]
    }), label && (0, _jsxRuntime.jsx)("span", {
      className: "caption2",
      css: css.label(selected),
      id: "label",
      children: label
    }), icon && (0, _jsxRuntime.jsx)("span", {
      css: {
        display: selected ? 'transparent' : 'none',
        height: 15,
        marginLeft: 8
      },
      children: icon
    }), onChange && // eslint-disable-next-line @typescript-eslint/ban-ts-comment

    /* @ts-ignore - TextButton can be a link or a button, so it doesn't like the onClick handler here */
    (0, _jsxRuntime.jsx)(_Button.Text, {
      className: "body3",
      onClick: onChange,
      children: "Change"
    })]
  }));
};

PaymentMethod.propTypes = {
  /**
   * Bank account number; all but the remaining four digits will be masked. Can be used instead of `cardNumber` for bank accounts.
   */
  accountNumber: _propTypes.string,

  /**
   * A string in the format of MM/YY.
   */
  cardExpiry: _propTypes.string,

  /**
   * Credit card number; all but the remaining four digits will be masked.
   */
  cardNumber: _propTypes.string,

  /**
   * Additional information to be shown alongside the expiry date.
   */
  cardState: _propTypes.string,

  /**
   * Providing a valid card type ensures the appropriate icon will be displayed.
   */
  cardType: (0, _propTypes.oneOf)([CARD_TYPES.BANKACCOUNT, CARD_TYPES.MC, CARD_TYPES.VISA]),

  /**
   * Prevent interaction with this payment method; `cardState` will be red if this is   `true`.
   */
  disabled: _propTypes.bool,

  /**
   * Renders a `Change` input if provided
   */
  onChange: _propTypes.func,

  /**
   * Render an active border around the component if `true`.
   */
  selected: _propTypes.bool,

  /**
   * A string on the right hand of the component that shows up on hover if present.
   */
  label: _propTypes.string,

  /**
   * An icon beside the right hand side label that shows up on selected if present.
   */
  icon: _propTypes.element,

  /**
   * Show the card type string beside the card number if `true`.
   */
  showCardType: _propTypes.bool
};
PaymentMethod.defaultProps = {
  accountNumber: undefined,
  cardExpiry: undefined,
  cardNumber: undefined,
  cardState: undefined,
  cardType: undefined,
  disabled: false,
  onChange: undefined,
  selected: false,
  label: undefined,
  icon: undefined,
  showCardType: false
};
var _default = PaymentMethod;
exports["default"] = _default;